<script lang="ts">
  /** In [0, 1] range */
  export let fill = 0

  let mounted = false
  let filled: "none" | "partial" | "full" = "none"

  $: if (fill < 0.33) filled = "none" // 0%
  else if (fill < 1) filled = "partial" // ~25%
  else if (fill >= 1) filled = "full" // 100%
</script>

<div class:mounted>
  <svg
    width="193"
    height="408"
    viewBox="0 0 193 408"
    fill="none"
    stroke="#fff"
    stroke-width="3"
    stroke-miterlimit="10"
    stroke-linecap="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 403.277V406"
      stroke-dasharray="2.722991943359375 5.44598388671875"
      stroke-dashoffset="4.222991943359375"
    /><path
      d="M13.2557 402.61L13.4946 405.891"
      stroke-dasharray="3.289691925048828 6.579383850097656"
      stroke-dashoffset="4.789691925048828"
    /><path
      d="M24.2865 401.18L24.8486 405.006"
      stroke-dasharray="3.86708927154541 7.73417854309082"
      stroke-dashoffset="5.36708927154541"
    /><path
      d="M35.0504 399.015L36.02 403.372"
      stroke-dasharray="4.463577747344971 8.927155494689941"
      stroke-dashoffset="5.963577747344971"
    /><path
      d="M45.5613 396.156L47.0086 400.989"
      stroke-dasharray="5.045061111450195 10.09012222290039"
      stroke-dashoffset="6.545061111450195"
    /><path
      d="M55.7913 392.616L57.7726 397.885"
      stroke-dasharray="5.629211902618408 11.258423805236816"
      stroke-dashoffset="7.129211902618408"
    /><path
      d="M65.7119 388.436L68.2975 394.086"
      stroke-dasharray="6.213514804840088 12.427029609680176"
      stroke-dashoffset="7.713514804840088"
    /><path
      d="M75.3236 383.616L78.5556 389.593"
      stroke-dasharray="6.7948689460754395 13.589737892150879"
      stroke-dashoffset="8.29486894607544"
    /><path
      d="M84.5839 378.197L88.5325 384.46"
      stroke-dasharray="7.403824806213379 14.807649612426758"
      stroke-dashoffset="8.903824806213379"
    /><path
      d="M93.4929 372.206L98.1863 378.673"
      stroke-dasharray="7.990636825561523 15.981273651123047"
      stroke-dashoffset="9.490636825561523"
    /><path
      d="M102.036 365.644L107.489 372.274"
      stroke-dasharray="8.58438777923584 17.16877555847168"
      stroke-dashoffset="10.08438777923584"
    /><path
      d="M110.173 358.563L116.44 365.29"
      stroke-dasharray="9.193920135498047 18.387840270996094"
      stroke-dashoffset="10.693920135498047"
    /><path
      d="M117.901 350.966L125.012 357.72"
      stroke-dasharray="9.807283401489258 19.614566802978516"
      stroke-dashoffset="11.307283401489258"
    /><path
      d="M125.208 342.892L133.162 349.605"
      stroke-dasharray="10.408203125 20.81640625"
      stroke-dashoffset="11.908203125"
    /><path
      d="M132.066 334.355L140.876 340.958"
      stroke-dasharray="11.009808540344238 22.019617080688477"
      stroke-dashoffset="12.509808540344238"
    /><path
      d="M138.459 325.369L148.127 331.796"
      stroke-dasharray="11.609331130981445 23.21866226196289"
      stroke-dashoffset="13.109331130981445"
    /><path
      d="M144.375 315.96L154.914 322.156"
      stroke-dasharray="12.225430488586426 24.45086097717285"
      stroke-dashoffset="13.725430488586426"
    /><path
      d="M149.771 306.171L161.182 312.053"
      stroke-dasharray="12.837807655334473 25.675615310668945"
      stroke-dashoffset="14.337807655334473"
    /><path
      d="M154.661 296.014L166.929 301.514"
      stroke-dasharray="13.444477081298828 26.888954162597656"
      stroke-dashoffset="14.944477081298828"
    /><path
      d="M159.004 285.489L172.114 290.554"
      stroke-dasharray="14.054396629333496 28.108793258666992"
      stroke-dashoffset="15.554396629333496"
    /><path
      d="M162.798 274.651L176.723 279.185"
      stroke-dasharray="14.644549369812012 29.289098739624023"
      stroke-dashoffset="16.14454936981201"
    /><path
      d="M166.001 263.514L180.742 267.462"
      stroke-dasharray="15.260527610778809 30.521055221557617"
      stroke-dashoffset="16.76052761077881"
    /><path
      d="M168.615 252.077L184.129 255.372"
      stroke-dasharray="15.8600435256958 31.7200870513916"
      stroke-dashoffset="17.3600435256958"
    /><path
      d="M170.61 240.395L186.883 242.968"
      stroke-dasharray="16.47515296936035 32.9503059387207"
      stroke-dashoffset="17.97515296936035"
    /><path
      d="M171.974 228.467L188.948 230.251"
      stroke-dasharray="17.067493438720703 34.134986877441406"
      stroke-dashoffset="18.567493438720703"
    /><path
      d="M172.69 216.336L190.34 217.248"
      stroke-dasharray="17.673540115356445 35.34708023071289"
      stroke-dashoffset="19.173540115356445"
    /><path
      d="M172.732 204H191"
      stroke-dasharray="18.26800537109375 36.5360107421875"
      stroke-dashoffset="19.76800537109375"
    /><path
      d="M172.69 191.664L190.34 190.752"
      stroke-dasharray="17.673540115356445 35.34708023071289"
      stroke-dashoffset="19.173540115356445"
    /><path
      d="M171.974 179.533L188.948 177.749"
      stroke-dasharray="17.067493438720703 34.134986877441406"
      stroke-dashoffset="18.567493438720703"
    /><path
      d="M170.61 167.606L186.883 165.032"
      stroke-dasharray="16.475311279296875 32.95062255859375"
      stroke-dashoffset="17.975311279296875"
    /><path
      d="M168.615 155.923L184.129 152.628"
      stroke-dasharray="15.8600435256958 31.7200870513916"
      stroke-dashoffset="17.3600435256958"
    /><path
      d="M166.001 144.487L180.742 140.538"
      stroke-dasharray="15.260787963867188 30.521575927734375"
      stroke-dashoffset="16.760787963867188"
    /><path
      d="M162.798 133.349L176.723 128.815"
      stroke-dasharray="14.644549369812012 29.289098739624023"
      stroke-dashoffset="16.14454936981201"
    /><path
      d="M159.004 122.511L172.114 117.446"
      stroke-dasharray="14.054407119750977 28.108814239501953"
      stroke-dashoffset="15.554407119750977"
    /><path
      d="M154.661 111.986L166.929 106.485"
      stroke-dasharray="13.44488525390625 26.8897705078125"
      stroke-dashoffset="14.94488525390625"
    /><path
      d="M149.771 101.829L161.182 95.9473"
      stroke-dasharray="12.837660789489746 25.675321578979492"
      stroke-dashoffset="14.337660789489746"
    /><path
      d="M144.375 92.0393L154.914 85.8442"
      stroke-dasharray="12.224966049194336 24.449932098388672"
      stroke-dashoffset="13.724966049194336"
    /><path
      d="M138.459 82.6311L148.127 76.2046"
      stroke-dasharray="11.60905647277832 23.21811294555664"
      stroke-dashoffset="13.10905647277832"
    /><path
      d="M132.066 73.645L140.876 67.0415"
      stroke-dasharray="11.010110855102539 22.020221710205078"
      stroke-dashoffset="12.510110855102539"
    /><path
      d="M125.208 65.108L133.162 58.3955"
      stroke-dasharray="10.407873153686523 20.815746307373047"
      stroke-dashoffset="11.907873153686523"
    /><path
      d="M117.901 57.0341L125.012 50.2808"
      stroke-dasharray="9.806802749633789 19.613605499267578"
      stroke-dashoffset="11.306802749633789"
    /><path
      d="M110.173 49.4365L116.44 42.7104"
      stroke-dasharray="9.19324779510498 18.38649559020996"
      stroke-dashoffset="10.69324779510498"
    /><path
      d="M102.036 42.3563L107.489 35.7256"
      stroke-dasharray="8.58494758605957 17.16989517211914"
      stroke-dashoffset="10.08494758605957"
    /><path
      d="M93.4929 35.7935L98.1863 29.3262"
      stroke-dasharray="7.990869998931885 15.98173999786377"
      stroke-dashoffset="9.490869998931885"
    /><path
      d="M84.5839 29.8027L88.5325 23.5396"
      stroke-dasharray="7.403908729553223 14.807817459106445"
      stroke-dashoffset="8.903908729553223"
    /><path
      d="M75.3236 24.384L78.5556 18.4067"
      stroke-dasharray="6.795142650604248 13.590285301208496"
      stroke-dashoffset="8.295142650604248"
    /><path
      d="M65.7119 19.564L68.2975 13.9136"
      stroke-dasharray="6.213883399963379 12.427766799926758"
      stroke-dashoffset="7.713883399963379"
    /><path
      d="M55.7913 15.384L57.7726 10.1147"
      stroke-dasharray="5.629480838775635 11.25896167755127"
      stroke-dashoffset="7.129480838775635"
    /><path
      d="M45.5613 11.8443L47.0086 7.01074"
      stroke-dasharray="5.045590400695801 10.091180801391602"
      stroke-dashoffset="6.545590400695801"
    /><path
      d="M35.0504 8.9849L36.02 4.62793"
      stroke-dasharray="4.463553428649902 8.927106857299805"
      stroke-dashoffset="5.963553428649902"
    /><path
      d="M24.2865 6.8201L24.8486 2.99414"
      stroke-dasharray="3.867030382156372 7.734060764312744"
      stroke-dashoffset="5.367030382156372"
    /><path
      d="M13.2557 5.39072L13.4946 2.10938"
      stroke-dasharray="3.290024995803833 6.580049991607666"
      stroke-dashoffset="4.790024995803833"
    /><path
      d="M2 4.7231V2"
      stroke-dasharray="2.723100185394287 5.446200370788574"
      stroke-dashoffset="4.223100185394287"
    />
  </svg>
  <svg
    class={`filled-${filled}`}
    width="193"
    height="408"
    viewBox="0 0 193 408"
    fill="none"
    stroke="#fff"
    stroke-width="3"
    stroke-miterlimit="10"
    stroke-linecap="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 403.277V406"
      stroke-dasharray="2.722991943359375 5.44598388671875"
      stroke-dashoffset="4.222991943359375"
    /><path
      d="M13.2557 402.61L13.4946 405.891"
      stroke-dasharray="3.289691925048828 6.579383850097656"
      stroke-dashoffset="4.789691925048828"
    /><path
      d="M24.2865 401.18L24.8486 405.006"
      stroke-dasharray="3.86708927154541 7.73417854309082"
      stroke-dashoffset="5.36708927154541"
    /><path
      d="M35.0504 399.015L36.02 403.372"
      stroke-dasharray="4.463577747344971 8.927155494689941"
      stroke-dashoffset="5.963577747344971"
    /><path
      d="M45.5613 396.156L47.0086 400.989"
      stroke-dasharray="5.045061111450195 10.09012222290039"
      stroke-dashoffset="6.545061111450195"
    /><path
      d="M55.7913 392.616L57.7726 397.885"
      stroke-dasharray="5.629211902618408 11.258423805236816"
      stroke-dashoffset="7.129211902618408"
    /><path
      d="M65.7119 388.436L68.2975 394.086"
      stroke-dasharray="6.213514804840088 12.427029609680176"
      stroke-dashoffset="7.713514804840088"
    /><path
      d="M75.3236 383.616L78.5556 389.593"
      stroke-dasharray="6.7948689460754395 13.589737892150879"
      stroke-dashoffset="8.29486894607544"
    /><path
      d="M84.5839 378.197L88.5325 384.46"
      stroke-dasharray="7.403824806213379 14.807649612426758"
      stroke-dashoffset="8.903824806213379"
    /><path
      d="M93.4929 372.206L98.1863 378.673"
      stroke-dasharray="7.990636825561523 15.981273651123047"
      stroke-dashoffset="9.490636825561523"
    /><path
      d="M102.036 365.644L107.489 372.274"
      stroke-dasharray="8.58438777923584 17.16877555847168"
      stroke-dashoffset="10.08438777923584"
    /><path
      d="M110.173 358.563L116.44 365.29"
      stroke-dasharray="9.193920135498047 18.387840270996094"
      stroke-dashoffset="10.693920135498047"
    /><path
      d="M117.901 350.966L125.012 357.72"
      stroke-dasharray="9.807283401489258 19.614566802978516"
      stroke-dashoffset="11.307283401489258"
    /><path
      d="M125.208 342.892L133.162 349.605"
      stroke-dasharray="10.408203125 20.81640625"
      stroke-dashoffset="11.908203125"
    /><path
      d="M132.066 334.355L140.876 340.958"
      stroke-dasharray="11.009808540344238 22.019617080688477"
      stroke-dashoffset="12.509808540344238"
    /><path
      d="M138.459 325.369L148.127 331.796"
      stroke-dasharray="11.609331130981445 23.21866226196289"
      stroke-dashoffset="13.109331130981445"
    /><path
      d="M144.375 315.96L154.914 322.156"
      stroke-dasharray="12.225430488586426 24.45086097717285"
      stroke-dashoffset="13.725430488586426"
    /><path
      d="M149.771 306.171L161.182 312.053"
      stroke-dasharray="12.837807655334473 25.675615310668945"
      stroke-dashoffset="14.337807655334473"
    /><path
      d="M154.661 296.014L166.929 301.514"
      stroke-dasharray="13.444477081298828 26.888954162597656"
      stroke-dashoffset="14.944477081298828"
    /><path
      d="M159.004 285.489L172.114 290.554"
      stroke-dasharray="14.054396629333496 28.108793258666992"
      stroke-dashoffset="15.554396629333496"
    /><path
      d="M162.798 274.651L176.723 279.185"
      stroke-dasharray="14.644549369812012 29.289098739624023"
      stroke-dashoffset="16.14454936981201"
    /><path
      d="M166.001 263.514L180.742 267.462"
      stroke-dasharray="15.260527610778809 30.521055221557617"
      stroke-dashoffset="16.76052761077881"
    /><path
      d="M168.615 252.077L184.129 255.372"
      stroke-dasharray="15.8600435256958 31.7200870513916"
      stroke-dashoffset="17.3600435256958"
    /><path
      d="M170.61 240.395L186.883 242.968"
      stroke-dasharray="16.47515296936035 32.9503059387207"
      stroke-dashoffset="17.97515296936035"
    /><path
      d="M171.974 228.467L188.948 230.251"
      stroke-dasharray="17.067493438720703 34.134986877441406"
      stroke-dashoffset="18.567493438720703"
    /><path
      d="M172.69 216.336L190.34 217.248"
      stroke-dasharray="17.673540115356445 35.34708023071289"
      stroke-dashoffset="19.173540115356445"
    /><path
      d="M172.732 204H191"
      stroke-dasharray="18.26800537109375 36.5360107421875"
      stroke-dashoffset="19.76800537109375"
    /><path
      d="M172.69 191.664L190.34 190.752"
      stroke-dasharray="17.673540115356445 35.34708023071289"
      stroke-dashoffset="19.173540115356445"
    /><path
      d="M171.974 179.533L188.948 177.749"
      stroke-dasharray="17.067493438720703 34.134986877441406"
      stroke-dashoffset="18.567493438720703"
    /><path
      d="M170.61 167.606L186.883 165.032"
      stroke-dasharray="16.475311279296875 32.95062255859375"
      stroke-dashoffset="17.975311279296875"
    /><path
      d="M168.615 155.923L184.129 152.628"
      stroke-dasharray="15.8600435256958 31.7200870513916"
      stroke-dashoffset="17.3600435256958"
    /><path
      d="M166.001 144.487L180.742 140.538"
      stroke-dasharray="15.260787963867188 30.521575927734375"
      stroke-dashoffset="16.760787963867188"
    /><path
      d="M162.798 133.349L176.723 128.815"
      stroke-dasharray="14.644549369812012 29.289098739624023"
      stroke-dashoffset="16.14454936981201"
    /><path
      d="M159.004 122.511L172.114 117.446"
      stroke-dasharray="14.054407119750977 28.108814239501953"
      stroke-dashoffset="15.554407119750977"
    /><path
      d="M154.661 111.986L166.929 106.485"
      stroke-dasharray="13.44488525390625 26.8897705078125"
      stroke-dashoffset="14.94488525390625"
    /><path
      d="M149.771 101.829L161.182 95.9473"
      stroke-dasharray="12.837660789489746 25.675321578979492"
      stroke-dashoffset="14.337660789489746"
    /><path
      d="M144.375 92.0393L154.914 85.8442"
      stroke-dasharray="12.224966049194336 24.449932098388672"
      stroke-dashoffset="13.724966049194336"
    /><path
      d="M138.459 82.6311L148.127 76.2046"
      stroke-dasharray="11.60905647277832 23.21811294555664"
      stroke-dashoffset="13.10905647277832"
    /><path
      d="M132.066 73.645L140.876 67.0415"
      stroke-dasharray="11.010110855102539 22.020221710205078"
      stroke-dashoffset="12.510110855102539"
    /><path
      d="M125.208 65.108L133.162 58.3955"
      stroke-dasharray="10.407873153686523 20.815746307373047"
      stroke-dashoffset="11.907873153686523"
    /><path
      d="M117.901 57.0341L125.012 50.2808"
      stroke-dasharray="9.806802749633789 19.613605499267578"
      stroke-dashoffset="11.306802749633789"
    /><path
      d="M110.173 49.4365L116.44 42.7104"
      stroke-dasharray="9.19324779510498 18.38649559020996"
      stroke-dashoffset="10.69324779510498"
    /><path
      d="M102.036 42.3563L107.489 35.7256"
      stroke-dasharray="8.58494758605957 17.16989517211914"
      stroke-dashoffset="10.08494758605957"
    /><path
      d="M93.4929 35.7935L98.1863 29.3262"
      stroke-dasharray="7.990869998931885 15.98173999786377"
      stroke-dashoffset="9.490869998931885"
    /><path
      d="M84.5839 29.8027L88.5325 23.5396"
      stroke-dasharray="7.403908729553223 14.807817459106445"
      stroke-dashoffset="8.903908729553223"
    /><path
      d="M75.3236 24.384L78.5556 18.4067"
      stroke-dasharray="6.795142650604248 13.590285301208496"
      stroke-dashoffset="8.295142650604248"
    /><path
      d="M65.7119 19.564L68.2975 13.9136"
      stroke-dasharray="6.213883399963379 12.427766799926758"
      stroke-dashoffset="7.713883399963379"
    /><path
      d="M55.7913 15.384L57.7726 10.1147"
      stroke-dasharray="5.629480838775635 11.25896167755127"
      stroke-dashoffset="7.129480838775635"
    /><path
      d="M45.5613 11.8443L47.0086 7.01074"
      stroke-dasharray="5.045590400695801 10.091180801391602"
      stroke-dashoffset="6.545590400695801"
    /><path
      d="M35.0504 8.9849L36.02 4.62793"
      stroke-dasharray="4.463553428649902 8.927106857299805"
      stroke-dashoffset="5.963553428649902"
    /><path
      d="M24.2865 6.8201L24.8486 2.99414"
      stroke-dasharray="3.867030382156372 7.734060764312744"
      stroke-dashoffset="5.367030382156372"
    /><path
      d="M13.2557 5.39072L13.4946 2.10938"
      stroke-dasharray="3.290024995803833 6.580049991607666"
      stroke-dashoffset="4.790024995803833"
    /><path
      d="M2 4.7231V2"
      stroke-dasharray="2.723100185394287 5.446200370788574"
      stroke-dashoffset="4.223100185394287"
    />
  </svg>
</div>

<style lang="postcss">
  div {
    @apply relative aspect-[193/408] h-[calc(404/387*100%)] w-auto;

    & > svg {
      @apply absolute inset-0 h-full w-full;
    }

    &.mounted > svg:nth-of-type(2) > path {
      @apply transition-[stroke-dashoffset] duration-500;
    }
  }

  svg:nth-of-type(1) {
    mask: linear-gradient(
      to left,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0.05) 36.82%,
      rgba(255, 255, 255, 0) 100%
    );

    & > path {
      @apply animate-[theme(transitionTimingFunction.DEFAULT)_300ms_1_forwards_draw];
    }

    & > path {
      &:nth-child(1) {
        animation-delay: 780ms;
      }

      &:nth-child(2) {
        animation-delay: 750ms;
      }

      &:nth-child(3) {
        animation-delay: 720ms;
      }

      &:nth-child(4) {
        animation-delay: 690ms;
      }

      &:nth-child(5) {
        animation-delay: 660ms;
      }

      &:nth-child(6) {
        animation-delay: 630ms;
      }

      &:nth-child(7) {
        animation-delay: 600ms;
      }

      &:nth-child(8) {
        animation-delay: 570ms;
      }

      &:nth-child(9) {
        animation-delay: 540ms;
      }

      &:nth-child(10) {
        animation-delay: 510ms;
      }

      &:nth-child(11) {
        animation-delay: 480ms;
      }

      &:nth-child(12) {
        animation-delay: 450ms;
      }

      &:nth-child(13) {
        animation-delay: 420ms;
      }

      &:nth-child(14) {
        animation-delay: 390ms;
      }

      &:nth-child(15) {
        animation-delay: 360ms;
      }

      &:nth-child(16) {
        animation-delay: 330ms;
      }

      &:nth-child(17) {
        animation-delay: 300ms;
      }

      &:nth-child(18) {
        animation-delay: 270ms;
      }

      &:nth-child(19) {
        animation-delay: 240ms;
      }

      &:nth-child(20) {
        animation-delay: 210ms;
      }

      &:nth-child(21) {
        animation-delay: 180ms;
      }

      &:nth-child(22) {
        animation-delay: 150ms;
      }

      &:nth-child(23) {
        animation-delay: 120ms;
      }

      &:nth-child(24) {
        animation-delay: 90ms;
      }

      &:nth-child(25) {
        animation-delay: 60ms;
      }

      &:nth-child(26) {
        animation-delay: 30ms;
      }

      &:nth-child(27) {
        animation-delay: 0ms;
      }

      &:nth-child(28) {
        animation-delay: 30ms;
      }

      &:nth-child(29) {
        animation-delay: 60ms;
      }

      &:nth-child(30) {
        animation-delay: 90ms;
      }

      &:nth-child(31) {
        animation-delay: 120ms;
      }

      &:nth-child(32) {
        animation-delay: 150ms;
      }

      &:nth-child(33) {
        animation-delay: 180ms;
      }

      &:nth-child(34) {
        animation-delay: 210ms;
      }

      &:nth-child(35) {
        animation-delay: 240ms;
      }

      &:nth-child(36) {
        animation-delay: 270ms;
      }

      &:nth-child(37) {
        animation-delay: 300ms;
      }

      &:nth-child(38) {
        animation-delay: 330ms;
      }

      &:nth-child(39) {
        animation-delay: 360ms;
      }

      &:nth-child(40) {
        animation-delay: 390ms;
      }

      &:nth-child(41) {
        animation-delay: 420ms;
      }

      &:nth-child(42) {
        animation-delay: 450ms;
      }

      &:nth-child(43) {
        animation-delay: 480ms;
      }

      &:nth-child(44) {
        animation-delay: 510ms;
      }

      &:nth-child(45) {
        animation-delay: 540ms;
      }

      &:nth-child(46) {
        animation-delay: 570ms;
      }

      &:nth-child(47) {
        animation-delay: 600ms;
      }

      &:nth-child(48) {
        animation-delay: 630ms;
      }

      &:nth-child(49) {
        animation-delay: 660ms;
      }

      &:nth-child(50) {
        animation-delay: 690ms;
      }

      &:nth-child(51) {
        animation-delay: 720ms;
      }

      &:nth-child(52) {
        animation-delay: 750ms;
      }

      &:nth-child(53) {
        animation-delay: 780ms;
      }
    }
  }

  svg:nth-of-type(2) {
    @apply stroke-current drop-shadow-[0px_0px_2.5px_currentColor];

    mask: linear-gradient(
      to left,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0.1) 55%,
      rgba(255, 255, 255, 0)
    );

    & > path {
      @apply transition-[stroke-dashoffset] duration-300;
    }

    &.filled-partial > path:nth-child(n + 20):nth-child(-n + 33) {
      stroke-dashoffset: 0;
    }
    &.filled-full > path {
      stroke-dashoffset: 0;
    }
  }

  @keyframes draw {
    100% {
      stroke-dashoffset: 0;
    }
  }
</style>
